export default __webpack_public_path__ + "static/media/hdrelay.3601cb3e.png";